// Reference from Rob Dongas class tutorial walkthrough
class $39350865381b08d9$var$Navigation {
    constructor(links, pages){
        this.links = links;
        this.pages = pages;
        this.currentPage = null;
    }
    getHash(link) {
        const href = link.getAttribute("href");
        return href ? href.replace("#", "") : "";
    }
    setPage(pageId) {
        if (!pageId) return;
        const targetPage = document.getElementById(pageId);
        if (!targetPage) return;
        this.currentPage = pageId;
        this.links.forEach((link)=>{
            const isActive = this.getHash(link) === pageId;
            link.classList.toggle("active", isActive);
        });
        this.pages.forEach((page)=>{
            page.style.display = "none";
        });
        targetPage.style.display = "block";
    }
    init(defaultPageId = null) {
        const firstPageId = defaultPageId || (this.links.length ? this.getHash(this.links[0]) : null);
        if (firstPageId) this.setPage(firstPageId);
    }
}
var $39350865381b08d9$export$2e2bcd8739ae039 = $39350865381b08d9$var$Navigation;


// Reference from Rob Dongas class tutorial walkthrough
// ── DOM references ──────────────────────────────────────────
const $8db409a62cbbbbd0$var$form = document.getElementById("taskform");
var $8db409a62cbbbbd0$var$taskInput = document.getElementById("taskInput");
var $8db409a62cbbbbd0$var$dueDateInput = document.getElementById("dueDateInput");
var $8db409a62cbbbbd0$var$completionTimeInput = document.getElementById("completionTimeInput");
var $8db409a62cbbbbd0$var$estimatedTimeInput = document.getElementById("estimatedTimeInput");
var $8db409a62cbbbbd0$var$priorityInput = document.getElementById("priorityInput");
var $8db409a62cbbbbd0$var$doIt = document.getElementById("do-it");
var $8db409a62cbbbbd0$var$schedule = document.getElementById("schedule");
var $8db409a62cbbbbd0$var$relegate = document.getElementById("relegate");
var $8db409a62cbbbbd0$var$dontDo = document.getElementById("dont-do");
// Drawer elements — needed to switch between Add / Edit modes
const $8db409a62cbbbbd0$var$drawerOverlay = document.querySelector('.task-modal');
const $8db409a62cbbbbd0$var$drawerTitle = document.querySelector('.drawer-header h2');
const $8db409a62cbbbbd0$var$submitBtn = document.querySelector('.drawer-submit');
const $8db409a62cbbbbd0$var$drawerCloseBtn = document.querySelector('.drawer-close');
// ── State ───────────────────────────────────────────────────
let $8db409a62cbbbbd0$var$tasklist;
let $8db409a62cbbbbd0$var$draggedItem = null;
let $8db409a62cbbbbd0$var$editingId = null; // null = adding new task, number = editing existing task
var $8db409a62cbbbbd0$var$taskListArray = [];
// ── localStorage ────────────────────────────────────────────
const $8db409a62cbbbbd0$var$LS_KEY = 'studbud-tasks';
// Walk all four quadrant boxes and snapshot every task + its current quadrant
// and completion state. Called after every state-changing action.
function $8db409a62cbbbbd0$var$saveTasks() {
    const quadrantMap = {
        'do-it': $8db409a62cbbbbd0$var$doIt,
        'schedule': $8db409a62cbbbbd0$var$schedule,
        'relegate': $8db409a62cbbbbd0$var$relegate,
        'dont-do': $8db409a62cbbbbd0$var$dontDo
    };
    const data = [];
    for (const [quadrantId, quadrantEl] of Object.entries(quadrantMap))quadrantEl.children[1].querySelectorAll('.itemDiv').forEach((item)=>{
        const id = Number(item.getAttribute('data-id'));
        const task = $8db409a62cbbbbd0$var$taskListArray.find((t)=>t.id === id);
        if (task) data.push({
            ...task,
            quadrant: quadrantId,
            completionStatus: item.classList.contains('completed')
        });
    });
    localStorage.setItem($8db409a62cbbbbd0$var$LS_KEY, JSON.stringify(data));
}
// Restore tasks from localStorage on page load.
// Uses the saved quadrant directly — does NOT re-run urgency/priority logic —
// so drag-and-drop decisions from the previous session are preserved.
function $8db409a62cbbbbd0$var$loadTasks() {
    let raw;
    try {
        raw = localStorage.getItem($8db409a62cbbbbd0$var$LS_KEY);
    } catch  {
        return;
    }
    if (!raw) return;
    let data;
    try {
        data = JSON.parse(raw);
    } catch  {
        return;
    }
    // Guard against double-initialization: clear any existing state before
    // repopulating so a second call never duplicates tasks in the array or DOM.
    $8db409a62cbbbbd0$var$taskListArray.length = 0;
    [
        $8db409a62cbbbbd0$var$doIt,
        $8db409a62cbbbbd0$var$schedule,
        $8db409a62cbbbbd0$var$relegate,
        $8db409a62cbbbbd0$var$dontDo
    ].forEach((q)=>{
        q.children[1].querySelectorAll('.itemDiv').forEach((el)=>el.remove());
    });
    const quadrantMap = {
        'do-it': $8db409a62cbbbbd0$var$doIt,
        'schedule': $8db409a62cbbbbd0$var$schedule,
        'relegate': $8db409a62cbbbbd0$var$relegate,
        'dont-do': $8db409a62cbbbbd0$var$dontDo
    };
    data.forEach((task)=>{
        $8db409a62cbbbbd0$var$taskListArray.push(task);
        const quadrantEl = quadrantMap[task.quadrant] || $8db409a62cbbbbd0$var$doIt;
        const item = $8db409a62cbbbbd0$var$createTaskElement(task);
        if (task.completionStatus) item.classList.add('completed');
        quadrantEl.children[1].appendChild(item);
    });
    $8db409a62cbbbbd0$var$sortAllQuadrants();
    $8db409a62cbbbbd0$var$updateEmpty();
}
// ── Form submission ─────────────────────────────────────────
$8db409a62cbbbbd0$var$form.addEventListener("submit", function(event) {
    event.preventDefault();
    if ($8db409a62cbbbbd0$var$editingId !== null) {
        $8db409a62cbbbbd0$var$saveEdit();
        return;
    }
    const task = $8db409a62cbbbbd0$var$taskInput.value;
    const dueDate = $8db409a62cbbbbd0$var$dueDateInput.value;
    const completionTime = $8db409a62cbbbbd0$var$completionTimeInput.value;
    const estimatedTime = $8db409a62cbbbbd0$var$estimatedTimeInput.value;
    const priorityRating = $8db409a62cbbbbd0$var$priorityInput.options[$8db409a62cbbbbd0$var$priorityInput.selectedIndex].value;
    if (task) {
        $8db409a62cbbbbd0$var$addTask(task, dueDate, estimatedTime, priorityRating, completionTime, false);
        $8db409a62cbbbbd0$var$drawerOverlay.style.display = 'none';
    }
});
// ── Add task ────────────────────────────────────────────────
function $8db409a62cbbbbd0$var$addTask(taskDescription, dueDate, estimatedTime, priorityRating, completionTime, completionStatus) {
    const task = {
        id: Date.now(),
        taskDescription: taskDescription,
        dueDate: dueDate,
        dateCreated: new Date().toISOString(),
        estimatedTime: estimatedTime,
        completionTime: completionTime,
        priorityRating: priorityRating,
        completionStatus: completionStatus
    };
    $8db409a62cbbbbd0$var$taskListArray.push(task);
    $8db409a62cbbbbd0$var$renderTask(task);
}
// ── Create task DOM element ─────────────────────────────────
// Pure factory — no quadrant logic. Used by renderTask (new tasks)
// and loadTasks (persisted tasks).
function $8db409a62cbbbbd0$var$createTaskElement(task) {
    const item = document.createElement('li');
    item.classList.add("itemDiv");
    item.setAttribute('data-id', task.id);
    item.setAttribute('draggable', 'true');
    item.innerHTML = '<span class="task-text">' + task.taskDescription + '</span>' + (task.dueDate ? '<span class="task-date">' + task.dueDate + '</span>' : '');
    // Drag events
    item.addEventListener('dragstart', ()=>{
        $8db409a62cbbbbd0$var$draggedItem = item;
        setTimeout(()=>item.classList.add('dragging'), 0);
    });
    item.addEventListener('dragend', ()=>{
        item.classList.remove('dragging');
        $8db409a62cbbbbd0$var$draggedItem = null;
    });
    // Move button (mobile only — hidden on desktop via CSS)
    const moveButton = document.createElement("button");
    moveButton.innerHTML = '<i class="fas fa-arrows-alt"></i>';
    moveButton.classList.add("move-btn");
    moveButton.setAttribute('title', 'Move to quadrant');
    moveButton.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        $8db409a62cbbbbd0$var$showMovePopover(e.currentTarget, item);
    });
    // Edit button
    const editButton = document.createElement("button");
    editButton.innerHTML = '<i class="fas fa-pencil-alt"></i>';
    editButton.classList.add("edit-btn");
    editButton.setAttribute('title', 'Edit task');
    editButton.addEventListener("click", function(e) {
        e.preventDefault();
        const id = Number(e.currentTarget.closest('li').getAttribute('data-id'));
        const t = $8db409a62cbbbbd0$var$taskListArray.find((t)=>t.id === id);
        if (t) $8db409a62cbbbbd0$var$openDrawerForEdit(t);
    });
    // Complete button
    const completedButton = document.createElement("button");
    completedButton.innerHTML = '<i class="fas fa-check"></i>';
    completedButton.classList.add("complete-btn");
    completedButton.setAttribute('title', 'Mark complete');
    completedButton.addEventListener("click", function(e) {
        e.currentTarget.closest('li').classList.toggle("completed");
        $8db409a62cbbbbd0$var$saveTasks();
    });
    // Delete button
    const delButton = document.createElement("button");
    delButton.innerHTML = '<i class="fas fa-times"></i>';
    delButton.classList.add('delete-btn');
    delButton.setAttribute('title', 'Remove task');
    delButton.addEventListener("click", function(e) {
        e.preventDefault();
        const li = e.currentTarget.closest('li');
        const id = Number(li.getAttribute('data-id'));
        const index = $8db409a62cbbbbd0$var$taskListArray.findIndex((t)=>t.id === id);
        $8db409a62cbbbbd0$var$removeItemFromArray($8db409a62cbbbbd0$var$taskListArray, index);
        li.remove();
        $8db409a62cbbbbd0$var$updateEmpty();
        $8db409a62cbbbbd0$var$saveTasks();
    });
    item.appendChild(moveButton);
    item.appendChild(editButton);
    item.appendChild(completedButton);
    item.appendChild(delButton);
    return item;
}
// ── Render new task (computes quadrant from urgency + priority)
function $8db409a62cbbbbd0$var$renderTask(task) {
    const currentDate = new Date();
    const taskDueDate = new Date(task.dueDate);
    const dateDiff = $8db409a62cbbbbd0$var$days_between(currentDate, taskDueDate);
    const urgencyValue = 5;
    if (dateDiff > urgencyValue) $8db409a62cbbbbd0$var$tasklist = task.priorityRating === "" || task.priorityRating === "Low" ? $8db409a62cbbbbd0$var$dontDo : $8db409a62cbbbbd0$var$schedule;
    else $8db409a62cbbbbd0$var$tasklist = task.priorityRating === "" || task.priorityRating === "Low" ? $8db409a62cbbbbd0$var$relegate : $8db409a62cbbbbd0$var$doIt;
    const box = $8db409a62cbbbbd0$var$tasklist.children[1];
    box.appendChild($8db409a62cbbbbd0$var$createTaskElement(task));
    $8db409a62cbbbbd0$var$sortQuadrantBox(box);
    $8db409a62cbbbbd0$var$form.reset();
    $8db409a62cbbbbd0$var$updateEmpty();
    $8db409a62cbbbbd0$var$saveTasks();
}
// ── Edit flow ───────────────────────────────────────────────
// Opens the drawer pre-filled with the task's current values.
// The form submit handler routes to saveEdit() while editingId is set.
function $8db409a62cbbbbd0$var$openDrawerForEdit(task) {
    $8db409a62cbbbbd0$var$editingId = task.id;
    $8db409a62cbbbbd0$var$taskInput.value = task.taskDescription;
    $8db409a62cbbbbd0$var$dueDateInput.value = task.dueDate || '';
    $8db409a62cbbbbd0$var$completionTimeInput.value = task.completionTime || '';
    $8db409a62cbbbbd0$var$estimatedTimeInput.value = task.estimatedTime || '';
    $8db409a62cbbbbd0$var$priorityInput.value = task.priorityRating || '';
    $8db409a62cbbbbd0$var$drawerTitle.textContent = 'Edit Task';
    $8db409a62cbbbbd0$var$submitBtn.textContent = 'Save Changes';
    $8db409a62cbbbbd0$var$drawerOverlay.style.display = 'block';
}
// Updates the task data and its existing DOM element in place.
// Does NOT re-run quadrant logic — the task stays in whichever
// quadrant the user placed it via drag-and-drop.
function $8db409a62cbbbbd0$var$saveEdit() {
    const task = $8db409a62cbbbbd0$var$taskListArray.find((t)=>t.id === $8db409a62cbbbbd0$var$editingId);
    if (!task) {
        $8db409a62cbbbbd0$var$resetEditState();
        return;
    }
    task.taskDescription = $8db409a62cbbbbd0$var$taskInput.value;
    task.dueDate = $8db409a62cbbbbd0$var$dueDateInput.value;
    task.completionTime = $8db409a62cbbbbd0$var$completionTimeInput.value;
    task.estimatedTime = $8db409a62cbbbbd0$var$estimatedTimeInput.value;
    task.priorityRating = $8db409a62cbbbbd0$var$priorityInput.options[$8db409a62cbbbbd0$var$priorityInput.selectedIndex].value;
    const item = document.querySelector(`[data-id="${$8db409a62cbbbbd0$var$editingId}"]`);
    if (item) {
        item.querySelector('.task-text').textContent = task.taskDescription;
        // Add, update, or remove the date span depending on new value
        let dateSpan = item.querySelector('.task-date');
        if (task.dueDate) {
            if (dateSpan) dateSpan.textContent = task.dueDate;
            else {
                dateSpan = document.createElement('span');
                dateSpan.className = 'task-date';
                dateSpan.textContent = task.dueDate;
                item.querySelector('.task-text').insertAdjacentElement('afterend', dateSpan);
            }
        } else if (dateSpan) dateSpan.remove();
        // Re-sort within its current quadrant so the updated due date is respected
        $8db409a62cbbbbd0$var$sortQuadrantBox(item.parentElement);
    }
    $8db409a62cbbbbd0$var$saveTasks();
    $8db409a62cbbbbd0$var$resetEditState();
}
// Resets drawer to Add-mode. Called after save, and also if the drawer
// is closed mid-edit (X button, backdrop click, Escape).
function $8db409a62cbbbbd0$var$resetEditState() {
    $8db409a62cbbbbd0$var$editingId = null;
    $8db409a62cbbbbd0$var$drawerTitle.textContent = 'New Task';
    $8db409a62cbbbbd0$var$submitBtn.textContent = 'Add Task';
    $8db409a62cbbbbd0$var$drawerOverlay.style.display = 'none';
    $8db409a62cbbbbd0$var$form.reset();
}
// Guard: reset edit state whenever drawer is dismissed without saving
$8db409a62cbbbbd0$var$drawerCloseBtn.addEventListener('click', function() {
    if ($8db409a62cbbbbd0$var$editingId !== null) $8db409a62cbbbbd0$var$resetEditState();
});
$8db409a62cbbbbd0$var$drawerOverlay.addEventListener('click', function(e) {
    if (e.target === $8db409a62cbbbbd0$var$drawerOverlay && $8db409a62cbbbbd0$var$editingId !== null) $8db409a62cbbbbd0$var$resetEditState();
});
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && $8db409a62cbbbbd0$var$editingId !== null) $8db409a62cbbbbd0$var$resetEditState();
});
// ── Sorting ─────────────────────────────────────────────────
// Sorts the li items in a ul.box by due date (earliest first).
// Items with no due date sort to the bottom (Infinity).
// Operates only on the box element — does not touch .emptyList.
function $8db409a62cbbbbd0$var$sortQuadrantBox(box) {
    const items = Array.from(box.querySelectorAll('.itemDiv'));
    items.sort((a, b)=>{
        const idA = Number(a.getAttribute('data-id'));
        const idB = Number(b.getAttribute('data-id'));
        const tA = $8db409a62cbbbbd0$var$taskListArray.find((t)=>t.id === idA);
        const tB = $8db409a62cbbbbd0$var$taskListArray.find((t)=>t.id === idB);
        const dA = tA && tA.dueDate ? new Date(tA.dueDate).getTime() : Infinity;
        const dB = tB && tB.dueDate ? new Date(tB.dueDate).getTime() : Infinity;
        return dA - dB;
    });
    items.forEach((item)=>box.appendChild(item));
}
function $8db409a62cbbbbd0$var$sortAllQuadrants() {
    [
        $8db409a62cbbbbd0$var$doIt,
        $8db409a62cbbbbd0$var$schedule,
        $8db409a62cbbbbd0$var$relegate,
        $8db409a62cbbbbd0$var$dontDo
    ].forEach((q)=>$8db409a62cbbbbd0$var$sortQuadrantBox(q.children[1]));
}
// ── Helpers ─────────────────────────────────────────────────
function $8db409a62cbbbbd0$var$removeItemFromArray(arr, index) {
    if (index > -1) arr.splice(index, 1);
    return arr;
}
function $8db409a62cbbbbd0$var$updateEmpty() {
    [
        $8db409a62cbbbbd0$var$doIt,
        $8db409a62cbbbbd0$var$schedule,
        $8db409a62cbbbbd0$var$relegate,
        $8db409a62cbbbbd0$var$dontDo
    ].forEach((q)=>{
        q.querySelector('.emptyList').style.display = q.children[1].childNodes.length > 0 ? 'none' : 'block';
    });
}
function $8db409a62cbbbbd0$var$days_between(date1, date2) {
    const ONE_DAY = 86400000;
    return Math.round(Math.abs(date1 - date2) / ONE_DAY);
}
// ── Mobile tap-to-move ──────────────────────────────────────
// Shows a compact popover so users can move a task to any quadrant
// without drag-and-drop. Moves the DOM node and calls saveTasks()
// via the same path as drag-drop, so persistence is identical.
const $8db409a62cbbbbd0$var$MOVE_TARGETS = [
    {
        label: 'Do Now',
        getBox: ()=>$8db409a62cbbbbd0$var$doIt.children[1]
    },
    {
        label: 'Schedule',
        getBox: ()=>$8db409a62cbbbbd0$var$schedule.children[1]
    },
    {
        label: 'Delegate',
        getBox: ()=>$8db409a62cbbbbd0$var$relegate.children[1]
    },
    {
        label: 'Eliminate',
        getBox: ()=>$8db409a62cbbbbd0$var$dontDo.children[1]
    }
];
let $8db409a62cbbbbd0$var$activeMovePopover = null;
function $8db409a62cbbbbd0$var$closeMovePopover() {
    if ($8db409a62cbbbbd0$var$activeMovePopover) {
        $8db409a62cbbbbd0$var$activeMovePopover.remove();
        $8db409a62cbbbbd0$var$activeMovePopover = null;
    }
}
function $8db409a62cbbbbd0$var$showMovePopover(triggerBtn, item) {
    $8db409a62cbbbbd0$var$closeMovePopover();
    const currentBox = item.parentElement;
    const popover = document.createElement('div');
    popover.className = 'move-popover';
    $8db409a62cbbbbd0$var$MOVE_TARGETS.forEach(({ label: label, getBox: getBox })=>{
        const targetBox = getBox();
        const btn = document.createElement('button');
        btn.className = 'move-popover-option';
        btn.textContent = label;
        if (currentBox === targetBox) btn.classList.add('move-popover-option--current');
        btn.addEventListener('click', (e)=>{
            e.stopPropagation();
            if (currentBox !== targetBox) {
                targetBox.appendChild(item);
                $8db409a62cbbbbd0$var$updateEmpty();
                $8db409a62cbbbbd0$var$saveTasks();
            }
            $8db409a62cbbbbd0$var$closeMovePopover();
        });
        popover.appendChild(btn);
    });
    document.body.appendChild(popover);
    $8db409a62cbbbbd0$var$activeMovePopover = popover;
    // Position relative to trigger button — prefer below, fall back to above
    const rect = triggerBtn.getBoundingClientRect();
    const popH = popover.offsetHeight || 152;
    const below = window.innerHeight - rect.bottom;
    const left = Math.max(8, Math.min(rect.right - popover.offsetWidth, window.innerWidth - 152));
    popover.style.position = 'fixed';
    popover.style.zIndex = '500';
    popover.style.left = left + 'px';
    popover.style.top = below >= popH + 8 ? rect.bottom + 4 + 'px' : Math.max(8, rect.top - popH - 4) + 'px';
}
document.addEventListener('click', (e)=>{
    if ($8db409a62cbbbbd0$var$activeMovePopover && !$8db409a62cbbbbd0$var$activeMovePopover.contains(e.target)) $8db409a62cbbbbd0$var$closeMovePopover();
});
// ── Drag-and-drop drop zones ─────────────────────────────────
function $8db409a62cbbbbd0$var$initDropZones() {
    [
        $8db409a62cbbbbd0$var$doIt,
        $8db409a62cbbbbd0$var$schedule,
        $8db409a62cbbbbd0$var$relegate,
        $8db409a62cbbbbd0$var$dontDo
    ].forEach((quadrant)=>{
        const box = quadrant.children[1];
        quadrant.addEventListener('dragover', (e)=>{
            e.preventDefault();
            quadrant.classList.add('drag-over');
        });
        quadrant.addEventListener('dragleave', (e)=>{
            if (!quadrant.contains(e.relatedTarget)) quadrant.classList.remove('drag-over');
        });
        quadrant.addEventListener('drop', (e)=>{
            e.preventDefault();
            quadrant.classList.remove('drag-over');
            if ($8db409a62cbbbbd0$var$draggedItem && $8db409a62cbbbbd0$var$draggedItem.parentElement !== box) {
                box.appendChild($8db409a62cbbbbd0$var$draggedItem);
                $8db409a62cbbbbd0$var$updateEmpty();
                $8db409a62cbbbbd0$var$saveTasks(); // persist the new quadrant assignment
            }
        });
    });
}
$8db409a62cbbbbd0$var$initDropZones();
$8db409a62cbbbbd0$var$loadTasks();


// Free Dictionary API — no key required
// https://dictionaryapi.dev/
const $e60bbe1349b265cf$var$input = document.querySelector('#input');
const $e60bbe1349b265cf$var$notFound = document.querySelector('.not-found');
const $e60bbe1349b265cf$var$wordBox = document.querySelector('.dict-word');
const $e60bbe1349b265cf$var$defBox = document.querySelector('.def');
const $e60bbe1349b265cf$var$synsBox = document.querySelector('.syns');
const $e60bbe1349b265cf$var$loading = document.querySelector('.loading');
const $e60bbe1349b265cf$var$placeholder = document.querySelector('.dict-placeholder');
const $e60bbe1349b265cf$var$result = document.querySelector('.dict-result');
const $e60bbe1349b265cf$var$synsSection = document.querySelector('.dict-syns');
function $e60bbe1349b265cf$var$resetState() {
    $e60bbe1349b265cf$var$notFound.innerText = '';
    $e60bbe1349b265cf$var$wordBox.innerText = '';
    $e60bbe1349b265cf$var$defBox.innerText = '';
    $e60bbe1349b265cf$var$synsBox.innerText = '';
    $e60bbe1349b265cf$var$result.style.display = 'none';
    $e60bbe1349b265cf$var$placeholder.style.display = 'none';
    $e60bbe1349b265cf$var$synsSection.style.display = 'block';
}
$e60bbe1349b265cf$var$input.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter') return;
    const word = $e60bbe1349b265cf$var$input.value.trim();
    if (word === '') return;
    $e60bbe1349b265cf$var$resetState();
    $e60bbe1349b265cf$var$getData(word);
});
async function $e60bbe1349b265cf$var$getData(word) {
    $e60bbe1349b265cf$var$loading.style.display = 'block';
    let data;
    try {
        const response = await fetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${encodeURIComponent(word)}`);
        if (response.status === 404) {
            $e60bbe1349b265cf$var$loading.style.display = 'none';
            $e60bbe1349b265cf$var$notFound.innerText = 'No result found.';
            return;
        }
        data = await response.json();
    } catch (err) {
        $e60bbe1349b265cf$var$loading.style.display = 'none';
        $e60bbe1349b265cf$var$notFound.innerText = 'Could not reach the dictionary. Check your connection.';
        return;
    }
    $e60bbe1349b265cf$var$loading.style.display = 'none';
    const entry = data[0];
    const meanings = entry.meanings || [];
    $e60bbe1349b265cf$var$wordBox.innerText = entry.word || word;
    const definition = meanings.flatMap((m)=>m.definitions || []).map((d)=>d.definition).find((d)=>d) || '';
    $e60bbe1349b265cf$var$defBox.innerText = definition;
    $e60bbe1349b265cf$var$result.style.display = 'block';
    const synonyms = meanings.flatMap((m)=>m.synonyms || []).filter((s)=>s).slice(0, 5);
    if (synonyms.length > 0) $e60bbe1349b265cf$var$synsBox.innerText = synonyms.join(', ');
    else $e60bbe1349b265cf$var$synsSection.style.display = 'none';
}


// Reference - learnt from = nehasoni05 (2021). Pomodoro-Clock. [online] Github. Available at: https://github.com/nehasoni05/Pomodoro-Clock
// ── Shared sound system ────────────────────────────────────
// Imported by pomodoro.js and stopwatch.js.
// The toggle button lives in the Pomodoro card; both modules
// read the same `soundEnabled` state.
let $cce14adf375c5bca$export$4634f4683c8e6b5a = true;
let $cce14adf375c5bca$var$audioCtx = null;
function $cce14adf375c5bca$var$getAudioCtx() {
    if (!$cce14adf375c5bca$var$audioCtx) $cce14adf375c5bca$var$audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    return $cce14adf375c5bca$var$audioCtx;
}
function $cce14adf375c5bca$export$e07292ec7cb04a8e(freq, duration, type, gain) {
    if (!$cce14adf375c5bca$export$4634f4683c8e6b5a) return;
    const ctx = $cce14adf375c5bca$var$getAudioCtx();
    const osc = ctx.createOscillator();
    const gainNode = ctx.createGain();
    osc.connect(gainNode);
    gainNode.connect(ctx.destination);
    osc.type = type || 'sine';
    osc.frequency.setValueAtTime(freq, ctx.currentTime);
    gainNode.gain.setValueAtTime(gain || 0.18, ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + duration);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
}
function $cce14adf375c5bca$export$80cb197f7ea4fe13(event) {
    if (event === 'session') {
        $cce14adf375c5bca$export$e07292ec7cb04a8e(523, 0.18, 'sine', 0.28);
        setTimeout(()=>$cce14adf375c5bca$export$e07292ec7cb04a8e(659, 0.25, 'sine', 0.24), 160);
    } else if (event === 'break') {
        $cce14adf375c5bca$export$e07292ec7cb04a8e(392, 0.22, 'sine', 0.24);
        setTimeout(()=>$cce14adf375c5bca$export$e07292ec7cb04a8e(330, 0.3, 'sine', 0.20), 180);
    } else if (event === 'end') {
        $cce14adf375c5bca$export$e07292ec7cb04a8e(440, 0.15, 'sine', 0.26);
        setTimeout(()=>$cce14adf375c5bca$export$e07292ec7cb04a8e(440, 0.15, 'sine', 0.22), 200);
        setTimeout(()=>$cce14adf375c5bca$export$e07292ec7cb04a8e(440, 0.22, 'sine', 0.18), 400);
    }
}
function $cce14adf375c5bca$export$8fd8f568faf1a530(event) {
    if (event === 'start') $cce14adf375c5bca$export$e07292ec7cb04a8e(600, 0.12, 'sine', 0.18);
    else if (event === 'stop') $cce14adf375c5bca$export$e07292ec7cb04a8e(480, 0.12, 'sine', 0.16);
    else if (event === 'lap') {
        $cce14adf375c5bca$export$e07292ec7cb04a8e(700, 0.08, 'sine', 0.15);
        setTimeout(()=>$cce14adf375c5bca$export$e07292ec7cb04a8e(700, 0.1, 'sine', 0.12), 100);
    } else if (event === 'clear') $cce14adf375c5bca$export$e07292ec7cb04a8e(320, 0.18, 'sine', 0.12);
}
function $cce14adf375c5bca$export$21b6365147580583(val) {
    $cce14adf375c5bca$export$4634f4683c8e6b5a = val;
}
function $cce14adf375c5bca$export$3f66b274a2143589() {
    const ctx = $cce14adf375c5bca$var$getAudioCtx();
    if (ctx.state === 'suspended') ctx.resume();
}


var $aed0e7bef1d900b6$var$startBtn = document.getElementById("pomo-start-button");
var $aed0e7bef1d900b6$var$resetBtn = document.getElementById("pomo-reset-button");
var $aed0e7bef1d900b6$var$increaseSession = document.getElementById("plusSession");
var $aed0e7bef1d900b6$var$decreaseSession = document.getElementById("minusSession");
var $aed0e7bef1d900b6$var$increaseBreak = document.getElementById("plusBreak");
var $aed0e7bef1d900b6$var$decreaseBreak = document.getElementById("minusBreak");
var $aed0e7bef1d900b6$var$pauseBtn = document.getElementById("pomo-pause-button");
var $aed0e7bef1d900b6$var$continueBtn = document.getElementById("pomo-continue-button");
var $aed0e7bef1d900b6$var$skipBtn = document.getElementById("pomo-skip-button");
var $aed0e7bef1d900b6$var$soundToggle = document.getElementById("pomo-sound-toggle");
var $aed0e7bef1d900b6$var$heading = document.getElementById("pomo-text");
var $aed0e7bef1d900b6$var$timerName;
var $aed0e7bef1d900b6$var$count = 0;
var $aed0e7bef1d900b6$var$pomoline = document.querySelector('.line');
var $aed0e7bef1d900b6$var$sessionTotalSec = 0;
var $aed0e7bef1d900b6$var$breakTotalSec = 0;
var $aed0e7bef1d900b6$var$inBreak = false;
// ── Sound toggle (shared system lives in sound.js) ─────────
var $aed0e7bef1d900b6$var$_soundOn = true;
$aed0e7bef1d900b6$var$soundToggle.addEventListener("click", function() {
    (0, $cce14adf375c5bca$export$3f66b274a2143589)(); // Ensures AudioContext is running from a real tap
    $aed0e7bef1d900b6$var$_soundOn = !$aed0e7bef1d900b6$var$_soundOn;
    (0, $cce14adf375c5bca$export$21b6365147580583)($aed0e7bef1d900b6$var$_soundOn);
    $aed0e7bef1d900b6$var$soundToggle.textContent = $aed0e7bef1d900b6$var$_soundOn ? 'Sound on' : 'Sound off';
    $aed0e7bef1d900b6$var$soundToggle.classList.toggle('pomo-sound-active', $aed0e7bef1d900b6$var$_soundOn);
});
// ── Session +/− ────────────────────────────────────────────
$aed0e7bef1d900b6$var$increaseSession.addEventListener("click", function() {
    var stime = document.getElementById("STIME");
    var disptime = document.getElementById("TIME").innerHTML;
    var changedisptime = document.getElementById("TIME");
    var min = parseInt(disptime.split(/[:]/)[0]) + 1;
    changedisptime.innerHTML = min + ":00";
    stime.innerHTML = min + " min";
});
$aed0e7bef1d900b6$var$decreaseSession.addEventListener("click", function() {
    var stime = document.getElementById("STIME");
    var disptime = document.getElementById("TIME").innerHTML;
    var changedisptime = document.getElementById("TIME");
    var min = parseInt(disptime.split(/[:]/)[0]);
    if (min > 1) min = min - 1;
    changedisptime.innerHTML = (min < 10 ? "0" + min : min) + ":00";
    stime.innerHTML = min + " min";
});
// ── Break +/− ──────────────────────────────────────────────
$aed0e7bef1d900b6$var$increaseBreak.addEventListener("click", function() {
    var btime = document.getElementById("BTIME");
    var min = parseInt(btime.innerHTML.split(/[ ]/)[0]) + 1;
    btime.innerHTML = min + " min";
});
$aed0e7bef1d900b6$var$decreaseBreak.addEventListener("click", function() {
    var btime = document.getElementById("BTIME");
    var min = parseInt(btime.innerHTML.split(/[ ]/)[0]);
    if (min > 1) min = min - 1;
    btime.innerHTML = min + " min";
});
// ── Start ──────────────────────────────────────────────────
$aed0e7bef1d900b6$var$startBtn.addEventListener("click", function() {
    (0, $cce14adf375c5bca$export$3f66b274a2143589)(); // First real gesture — unlock AudioContext for all future sounds
    document.getElementById("SBTN").style.display = 'none';
    document.getElementById("CBTN").style.display = 'none';
    document.getElementById("PBTN").style.display = 'block';
    $aed0e7bef1d900b6$var$heading.innerHTML = "Focus in progress";
    $aed0e7bef1d900b6$var$sessionTotalSec = parseInt(document.getElementById("STIME").innerHTML) * 60;
    $aed0e7bef1d900b6$var$pomoline.style.width = '220px';
    $aed0e7bef1d900b6$var$inBreak = false;
    $aed0e7bef1d900b6$var$skipBtn.disabled = false;
    $aed0e7bef1d900b6$var$increaseSession.disabled = true;
    $aed0e7bef1d900b6$var$decreaseSession.disabled = true;
    $aed0e7bef1d900b6$var$increaseBreak.disabled = true;
    $aed0e7bef1d900b6$var$decreaseBreak.disabled = true;
    (0, $cce14adf375c5bca$export$80cb197f7ea4fe13)('session');
    $aed0e7bef1d900b6$var$startTimer();
});
function $aed0e7bef1d900b6$var$startTimer() {
    var presentTime = document.getElementById("TIME").innerHTML;
    var changedisptime = document.getElementById("TIME");
    var timeArray = presentTime.split(/[:]/);
    var min = $aed0e7bef1d900b6$var$checkMinute(parseInt(timeArray[0] - 0));
    var s = parseInt(timeArray[1]) - 1;
    var sec = $aed0e7bef1d900b6$var$checkSeconds(s);
    if (sec == 59) {
        min = min - 1;
        if (min < 10) min = "0" + min;
    }
    changedisptime.innerHTML = min + ":" + sec;
    if (min == 0 && sec == 0) {
        document.getElementById("SBTN").style.display = 'block';
        document.getElementById("CBTN").style.display = 'none';
        document.getElementById("PBTN").style.display = 'none';
        (0, $cce14adf375c5bca$export$80cb197f7ea4fe13)('end');
        $aed0e7bef1d900b6$var$breakTime();
        return;
    }
    $aed0e7bef1d900b6$var$updateLine(parseInt(min) * 60 + parseInt(sec), $aed0e7bef1d900b6$var$sessionTotalSec, 220);
    $aed0e7bef1d900b6$var$timerName = setTimeout($aed0e7bef1d900b6$var$startTimer, 1000);
}
// ── Pause ──────────────────────────────────────────────────
$aed0e7bef1d900b6$var$pauseBtn.addEventListener("click", function() {
    clearTimeout($aed0e7bef1d900b6$var$timerName);
    document.getElementById("SBTN").style.display = 'none';
    document.getElementById("CBTN").style.display = 'block';
    document.getElementById("PBTN").style.display = 'none';
    $aed0e7bef1d900b6$var$skipBtn.disabled = true;
    $aed0e7bef1d900b6$var$heading.innerHTML = "Paused";
});
// ── Resume ─────────────────────────────────────────────────
$aed0e7bef1d900b6$var$continueBtn.addEventListener("click", function() {
    (0, $cce14adf375c5bca$export$3f66b274a2143589)(); // Re-unlock in case context was suspended while paused
    clearTimeout($aed0e7bef1d900b6$var$timerName);
    document.getElementById("SBTN").style.display = 'none';
    document.getElementById("CBTN").style.display = 'none';
    document.getElementById("PBTN").style.display = 'block';
    $aed0e7bef1d900b6$var$skipBtn.disabled = false;
    $aed0e7bef1d900b6$var$heading.innerHTML = "Focus in progress";
    $aed0e7bef1d900b6$var$startTimer();
});
// ── Skip ───────────────────────────────────────────────────
$aed0e7bef1d900b6$var$skipBtn.addEventListener("click", function() {
    (0, $cce14adf375c5bca$export$3f66b274a2143589)(); // Skip is a user gesture — keep context alive
    clearTimeout($aed0e7bef1d900b6$var$timerName);
    if ($aed0e7bef1d900b6$var$inBreak) {
        (0, $cce14adf375c5bca$export$80cb197f7ea4fe13)('end');
        $aed0e7bef1d900b6$var$resetPomodoro();
    } else {
        (0, $cce14adf375c5bca$export$80cb197f7ea4fe13)('end');
        $aed0e7bef1d900b6$var$breakTime();
    }
});
// ── Reset ──────────────────────────────────────────────────
$aed0e7bef1d900b6$var$resetBtn.addEventListener("click", $aed0e7bef1d900b6$var$resetPomodoro);
function $aed0e7bef1d900b6$var$resetPomodoro() {
    clearTimeout($aed0e7bef1d900b6$var$timerName);
    var sessionMin = parseInt(document.getElementById("STIME").innerHTML);
    var displayMin = sessionMin < 10 ? "0" + sessionMin : "" + sessionMin;
    document.getElementById("TIME").innerHTML = displayMin + ":00";
    document.getElementById("SBTN").style.display = "block";
    document.getElementById("PBTN").style.display = "none";
    document.getElementById("CBTN").style.display = "none";
    $aed0e7bef1d900b6$var$heading.innerHTML = "Start Working!";
    $aed0e7bef1d900b6$var$pomoline.style.background = "red";
    $aed0e7bef1d900b6$var$pomoline.style.width = '220px';
    $aed0e7bef1d900b6$var$skipBtn.disabled = true;
    $aed0e7bef1d900b6$var$inBreak = false;
    $aed0e7bef1d900b6$var$increaseSession.disabled = false;
    $aed0e7bef1d900b6$var$decreaseSession.disabled = false;
    $aed0e7bef1d900b6$var$increaseBreak.disabled = false;
    $aed0e7bef1d900b6$var$decreaseBreak.disabled = false;
    $aed0e7bef1d900b6$var$count = 0;
}
// ── Break ──────────────────────────────────────────────────
function $aed0e7bef1d900b6$var$breakTime() {
    var bMin = document.getElementById("BTIME").innerHTML;
    var changedisptime = document.getElementById("TIME");
    var timeArray = bMin.split(/[ ]/);
    var min = timeArray[0];
    changedisptime.innerHTML = "0" + min + ":00";
    $aed0e7bef1d900b6$var$count = $aed0e7bef1d900b6$var$count + 1;
    $aed0e7bef1d900b6$var$heading.innerHTML = "Break time";
    $aed0e7bef1d900b6$var$pomoline.style.background = 'blue';
    $aed0e7bef1d900b6$var$breakTotalSec = parseInt(timeArray[0]) * 60;
    $aed0e7bef1d900b6$var$pomoline.style.width = '220px';
    $aed0e7bef1d900b6$var$inBreak = true;
    $aed0e7bef1d900b6$var$skipBtn.disabled = false;
    (0, $cce14adf375c5bca$export$80cb197f7ea4fe13)('break');
    $aed0e7bef1d900b6$var$startBreak();
}
function $aed0e7bef1d900b6$var$startBreak() {
    var presentTime = document.getElementById("TIME").innerHTML;
    var changedisptime = document.getElementById("TIME");
    var timeArray = presentTime.split(/[:]/);
    var min = $aed0e7bef1d900b6$var$checkMinute(parseInt(timeArray[0] - 0));
    var s = parseInt(timeArray[1]) - 1;
    var sec = $aed0e7bef1d900b6$var$checkSeconds(s);
    if (sec == 59) {
        min = min - 1;
        if (min < 10) min = "0" + min;
    }
    changedisptime.innerHTML = min + ":" + sec;
    if (min == 0 && sec == 0) {
        clearTimeout($aed0e7bef1d900b6$var$timerName);
        (0, $cce14adf375c5bca$export$80cb197f7ea4fe13)('end');
        alert("Break over. You can start your session again!");
        $aed0e7bef1d900b6$var$resetPomodoro();
        return;
    }
    $aed0e7bef1d900b6$var$updateLine(parseInt(min) * 60 + parseInt(sec), $aed0e7bef1d900b6$var$breakTotalSec, 220);
    $aed0e7bef1d900b6$var$timerName = setTimeout($aed0e7bef1d900b6$var$startBreak, 1000);
}
// ── Helpers ────────────────────────────────────────────────
function $aed0e7bef1d900b6$var$updateLine(remainingSec, totalSec, maxPx) {
    var ratio = totalSec > 0 ? remainingSec / totalSec : 1;
    $aed0e7bef1d900b6$var$pomoline.style.width = Math.round(ratio * maxPx) + 'px';
}
function $aed0e7bef1d900b6$var$checkMinute(min) {
    if (min < 10) min = "0" + min;
    return min;
}
function $aed0e7bef1d900b6$var$checkSeconds(s) {
    var sec = parseInt(s);
    if (sec < 10 && sec >= 0) sec = "0" + sec;
    if (sec < 0) sec = "59";
    return sec;
}


// Reference - learnt from = Chris (2021). stopwatch using javascript - accurate and easy. [online] dev.to. Available at: https://dev.to/chrislemus/stopwatch-using-javascript-accurate-and-easy-5ado

const $e923d53536dc2b7e$var$swTime = document.querySelector('.stopwatch');
const $e923d53536dc2b7e$var$swMainButton = document.querySelector('#stopwatch-main-button');
const $e923d53536dc2b7e$var$lapButton = document.querySelector('#stopwatch-lap-button');
const $e923d53536dc2b7e$var$clearButton = document.querySelector('#stopwatch-reset-button');
const $e923d53536dc2b7e$var$stopwatch = {
    elapsedTime: 0
};
const $e923d53536dc2b7e$var$swLapList = document.querySelector('.sw-lap-list');
const $e923d53536dc2b7e$var$swLapsEmpty = document.querySelector('.sw-laps-empty');
let $e923d53536dc2b7e$var$lapCount = 0;
// Lap button disabled until stopwatch is running
$e923d53536dc2b7e$var$lapButton.disabled = true;
$e923d53536dc2b7e$var$swMainButton.addEventListener('click', ()=>{
    if ($e923d53536dc2b7e$var$swMainButton.innerHTML === 'Start') {
        $e923d53536dc2b7e$var$startStopwatch();
        $e923d53536dc2b7e$var$swMainButton.innerHTML = 'Stop';
        $e923d53536dc2b7e$var$lapButton.disabled = false;
        (0, $cce14adf375c5bca$export$8fd8f568faf1a530)('start');
    } else {
        $e923d53536dc2b7e$var$stopwatch.elapsedTime += Date.now() - $e923d53536dc2b7e$var$stopwatch.startTime;
        clearInterval($e923d53536dc2b7e$var$stopwatch.intervalId);
        $e923d53536dc2b7e$var$swMainButton.innerHTML = 'Start';
        $e923d53536dc2b7e$var$lapButton.disabled = true;
        (0, $cce14adf375c5bca$export$8fd8f568faf1a530)('stop');
    }
});
$e923d53536dc2b7e$var$lapButton.addEventListener('click', ()=>{
    $e923d53536dc2b7e$var$lapCount++;
    $e923d53536dc2b7e$var$renderLap($e923d53536dc2b7e$var$lapCount, $e923d53536dc2b7e$var$swTime.innerHTML);
    $e923d53536dc2b7e$var$updateLapEmpty();
    (0, $cce14adf375c5bca$export$8fd8f568faf1a530)('lap');
});
$e923d53536dc2b7e$var$clearButton.addEventListener('click', ()=>{
    $e923d53536dc2b7e$var$stopwatch.elapsedTime = 0;
    $e923d53536dc2b7e$var$stopwatch.startTime = Date.now();
    $e923d53536dc2b7e$var$displayTime(0, 0, 0, 0);
    $e923d53536dc2b7e$var$lapCount = 0;
    $e923d53536dc2b7e$var$swLapList.innerHTML = '';
    $e923d53536dc2b7e$var$updateLapEmpty();
    (0, $cce14adf375c5bca$export$8fd8f568faf1a530)('clear');
});
function $e923d53536dc2b7e$var$startStopwatch() {
    $e923d53536dc2b7e$var$stopwatch.startTime = Date.now();
    $e923d53536dc2b7e$var$stopwatch.intervalId = setInterval(()=>{
        const elapsedTime = Date.now() - $e923d53536dc2b7e$var$stopwatch.startTime + $e923d53536dc2b7e$var$stopwatch.elapsedTime;
        const milliseconds = parseInt(elapsedTime % 1000 / 10);
        const seconds = parseInt(elapsedTime / 1000 % 60);
        const minutes = parseInt(elapsedTime / 60000 % 60);
        const hour = parseInt(elapsedTime / 3600000 % 24);
        $e923d53536dc2b7e$var$displayTime(hour, minutes, seconds, milliseconds);
    }, 100);
}
function $e923d53536dc2b7e$var$displayTime(hour, minutes, seconds, milliseconds) {
    const leadZeroTime = [
        hour,
        minutes,
        seconds,
        milliseconds
    ].map((t)=>t < 10 ? `0${t}` : t);
    $e923d53536dc2b7e$var$swTime.innerHTML = leadZeroTime.join(':');
}
function $e923d53536dc2b7e$var$updateLapEmpty() {
    $e923d53536dc2b7e$var$swLapsEmpty.style.display = $e923d53536dc2b7e$var$swLapList.children.length === 0 ? 'block' : 'none';
}
function $e923d53536dc2b7e$var$renderLap(num, timeStr) {
    const li = document.createElement('li');
    li.classList.add('sw-lap-item');
    const numSpan = document.createElement('span');
    numSpan.classList.add('sw-lap-num');
    numSpan.textContent = `${num < 10 ? '0' : ''}${num}`;
    const timeSpan = document.createElement('span');
    timeSpan.classList.add('sw-lap-time');
    timeSpan.textContent = timeStr;
    const delBtn = document.createElement('button');
    delBtn.innerHTML = '<i class="fas fa-times"></i>';
    delBtn.classList.add('delete-btn');
    delBtn.setAttribute('title', 'Remove lap');
    delBtn.addEventListener('click', ()=>{
        li.remove();
        // Re-number remaining laps
        Array.from($e923d53536dc2b7e$var$swLapList.children).forEach((item, i)=>{
            const n = i + 1;
            item.querySelector('.sw-lap-num').textContent = `${n < 10 ? '0' : ''}${n}`;
        });
        $e923d53536dc2b7e$var$lapCount = $e923d53536dc2b7e$var$swLapList.children.length;
        $e923d53536dc2b7e$var$updateLapEmpty();
    });
    li.appendChild(numSpan);
    li.appendChild(timeSpan);
    li.appendChild(delBtn);
    $e923d53536dc2b7e$var$swLapList.appendChild(li);
}


// Music card — no custom logic. Spotify embed handles everything.


document.addEventListener("DOMContentLoaded", function() {
    // Timer tab navigation
    const links = document.querySelectorAll(".timer-nav > ul > li > a");
    const pages = document.querySelectorAll(".timer-page-container");
    if (links.length && pages.length) {
        const timerNav = new (0, $39350865381b08d9$export$2e2bcd8739ae039)(links, pages);
        // Set default page
        timerNav.init("pomodoro");
        timerNav.links.forEach(function(link) {
            link.addEventListener("click", function(e) {
                e.preventDefault();
                const pageId = timerNav.getHash(link);
                if (!pageId || pageId === timerNav.currentPage) return;
                timerNav.setPage(pageId);
            });
        });
    }
    // Multiple modals
    const modals = document.getElementsByClassName("modal");
    const openButtons = document.getElementsByClassName("openBtn");
    const closeButtons = document.getElementsByClassName("closeBtn");
    function openModal(index) {
        if (modals[index]) modals[index].style.display = "block";
    }
    function closeModal(index) {
        if (modals[index]) modals[index].style.display = "none";
    }
    function closeAllModals() {
        Array.from(modals).forEach((modal)=>{
            modal.style.display = "none";
        });
    }
    Array.from(openButtons).forEach((button, index)=>{
        button.addEventListener("click", function() {
            openModal(index);
        });
    });
    Array.from(closeButtons).forEach((button, index)=>{
        button.addEventListener("click", function() {
            closeModal(index);
        });
    });
    // Close modal on backdrop click
    window.addEventListener("click", function(event) {
        Array.from(modals).forEach((modal)=>{
            if (event.target === modal) modal.style.display = "none";
        });
    });
    // Escape key closes all open modals
    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape") closeAllModals();
    });
});


//# sourceMappingURL=public.293da4e0.js.map
